export default "__VITE_ASSET__CVSHqhN1__"